import React, { useState } from 'react';
import { WalletIcon } from 'lucide-react';
interface WalletBalanceProps {
  availableBalance: number;
  onBalanceApplied: (amount: number) => void;
  onBalanceRemoved: () => void;
}
export function WalletBalance({
  availableBalance,
  onBalanceApplied,
  onBalanceRemoved
}: WalletBalanceProps) {
  const [isEnabled, setIsEnabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const handleToggle = () => {
    if (isEnabled) {
      setIsEnabled(false);
      onBalanceRemoved();
    } else {
      setIsEnabled(true);
      onBalanceApplied(availableBalance);
    }
  };
  return <>
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-6" data-id="element-1927" data-mp="273fgc324d9ih">
        <div className="flex items-center justify-between" data-id="element-1928" data-mp="2265iq04ktrjk">
          <div className="flex items-center gap-3" data-id="element-1929" data-mp="227qcvomzb8gw">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-sage-light" data-id="element-1930" data-mp="vptr6hw9f7wy">
              <WalletIcon className="h-5 w-5 text-sage-dark" data-id="element-1931" data-mp="qpfkb36ea40i" />
            </div>
            <div data-id="element-1932" data-mp="5edp7uo7wv0b">
              <h3 className="text-sm md:text-base font-bold text-gray-900" data-id="element-1933" data-mp="5fyk5leg2fyp">
                Use Wallet Balance
              </h3>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-1934" data-mp="9fph66ukdsbo">
                Available:{' '}
                <span className="font-bold text-brand" data-id="element-1935" data-mp="3rllsmrfkurtp">
                  SAR {availableBalance.toFixed(2)}
                </span>
              </p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer" data-id="element-1936" data-mp="3hvimdpjg3hdf">
            <input type="checkbox" checked={isEnabled} onChange={handleToggle} className="sr-only peer" data-id="element-1937" data-mp="3mnafo7tzk179" />
            <div className="peer relative h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:content-[''] after:transition-transform peer-checked:after:translate-x-full peer-checked:after:border-white peer-checked:bg-brand peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand/20" data-id="element-1938" data-mp="3duqep0q81kj9"></div>
          </label>
        </div>
        {isEnabled && <div className="mt-3 rounded-lg border border-sage-border bg-sage-soft p-3" data-id="element-1939" data-mp="2fz4jdtaprd5o">
            <p className="text-xs text-sage-dark md:text-sm" data-id="element-1940" data-mp="2b2e2j3r34dj7">
              ✓ SAR {availableBalance.toFixed(2)} will be deducted from your
              wallet
            </p>
          </div>}
      </div>
      {/* Wallet Balance Modal */}
      {modalOpen && <>
          {/* Desktop Modal */}
          <div className="hidden md:block fixed inset-0 z-[60] overflow-y-auto" data-id="element-1941" data-mp="2ypulvgwdgxy0">
            {/* ... existing modal code ... */}
          </div>
          {/* Mobile Bottom Sheet */}
          <div className="md:hidden fixed inset-0 z-[60]" data-id="element-1942" data-mp="2ot9hmxs6fqv8">
            {/* ... existing bottom sheet code ... */}
          </div>
        </>}
    </>;
}